module.exports = __webpack_public_path__ + "assets/img/gray_cross.1b249909.svg";